module.exports = __webpack_public_path__ + "img/plus.c2a0f0a0.svg";